import * as React from "react";
import { TimedChangbleFrame } from "../../../../components";

const betFinishedClass = "rj-my-pulse-bets__bet-finished-frame";

export class BetFinishedFrame extends React.Component<{
    won?: { amount: string },
    actions: { text: string, handler: () => void },
    goMsg: string,
    winMsg: string,
    removeBetHandler: () => void,
}, {}> {

    render() {

        let viewData: { childrenData: { timeOutMili: number, timedOutHandler?: () => void }, element: JSX.Element }[] = [];
        /*istanbul ignore next */
        if (this.props.won) {
            /*istanbul ignore next */
            viewData.push({
                childrenData: { timeOutMili: 2000 },
                element:
                    <div className={`${betFinishedClass} ${betFinishedClass}--container`}>
                        <div className={`${betFinishedClass}-message ${betFinishedClass}-message-goal`}>
                            {this.props.goMsg}
                        </div>
                    </div>
            });
            /*istanbul ignore next */
            viewData.push({

                childrenData: {
                    timeOutMili: 3800,
                    /* istanbul ignore next */
                    timedOutHandler: () => this.setState({ previewFinished: true })
                },
                element:
                    <div className={`${betFinishedClass} ${betFinishedClass}--container`}>
                        <div className={`${betFinishedClass}-message ${betFinishedClass}-message-win`}>
                            {this.props.winMsg}

                        </div>
                    </div>
            });
        }
        /* istanbul ignore next */
        viewData.push({
            childrenData: { timeOutMili: 5000, timedOutHandler: () => this.props.removeBetHandler() },
            element:
                <div className={`${betFinishedClass} ${betFinishedClass}--try-again-wrapper`}>
                    {/* Repeat a bet btn will be implemented later */}
                    {/* <PulseBetButton handler={this.props.actions.handler} modifier="repeat-button">
                        {this.props.actions.text}
                    </PulseBetButton> */}
                </div>
        });

        return (
            <TimedChangbleFrame key="2" childrenData={viewData.map((d) => d.childrenData)}>
                {viewData.map((d, index) => <React.Fragment key={index}>{d.element}</React.Fragment>)}
            </TimedChangbleFrame>
        )
    }
}